// extracted by mini-css-extract-plugin
module.exports = {"quotationBlocks":"QuotationBlocks_quotationBlocks__iKDmj","h3":"QuotationBlocks_h3__oHN8V","footnote":"QuotationBlocks_footnote__ULfuM"};